export const FINNISH_TRANSLATIONS = {
    tuka: {
        frontpage: 'Etusivu',
        site: {
            name: 'Verkkojulkaisu',
        },
        dropdown: {
            select_language: 'Valitse kieli'
        },
        search: {
            search: 'Hae',
            clear: 'Tyhjennä',
            text_search: 'Tekstihaku',
            text_results_header: 'Haku sanalla',
            text_results_clear: 'Palaa takaisin',
            text_results_count: 'Tuloksia:',
            text_results_in_header: 'Otsikossa:',
            text_results_in_content: 'Sisällössä:',
            text_results_in_categories: 'Kategoriossa:',
            text_results_count_in_single_article: 'Koko luvussa osumia',
            text_input_placeholder: 'Hae julkaisun sisällöstä',
            header: 'Otsikko',
            theme_word: 'Teemasana',
            theme_word_search: 'Teeman valinta',
            theme_words: 'Teemat:',
            theme_word_filtered: 'Navigaatio ja sisältö suodatettu arvoilla:',
            theme_word_filter_clear: 'Tyhjennä Teemat-filtteri'
        },
        navigation: {
            table_of_contents: 'Sisältö',
            table_of_contents_filtered: 'Sisältö teemalla ',
            table_of_contents_filtered_simple: 'Sisältö valitulla teemalla',
            show_all_content: 'Näytä koko julkaisu',
            page_name: 'Sivun nimi:',
            view: 'Näkymä',
            index_info: 'Aktiivisen kohteen index:',
            open_sidebar : 'Näytä sisällysluettelo',
            close_sidebar : 'Piilota sisällysluettelo',
            sidebar_open: 'Sisällysluettelo auki',
            sidebar_closed: 'Sisällysluettelo kiinni',
            accordion_open: 'Alaotsikot auki',
            accordion_closed: 'Alaotsikot kiinni',
            skip_to_active_sidebar_item: 'Palaa sisällysluetteloon',
            skip_to_main_content: 'Ohita sisällysluettelo'
        },
        messages: {
            no_active_themewords: {
                header: 'Näkyvällä sisällöllä ei havaittu valittua teemaa',
                content: 'Voit kokeilla valita uuden web-sisällön sivupalkista, vaihtaa valitun teeman tai suorittaa uuden sisältö-haun.'
            },
            no_web_content: {
                header: 'Etsittyä web-sisältöä ei löytynyt',
                content: '<div><h2>Etsittyä web-sisältöä ei löytynyt</h2><div>Voit kokeilla valita uuden web-sisällön sivupalkista tai suorittaa uuden sisältö-haun.</div></div>'
            },
            no_search_results: 'Hakutuloksia ei löytynyt. Voit kokeilla toista hakusanaa ja hakea uudestaan.'
        },
        warnings: {
            textSearchValueLength: 'Hakusanassa merkkejä vähintään:'
        },
        content: {
            table_caption: "Taulukko",
            figure_caption: "Kuvio",
            info_box: "Tietolaatikko"
        },
        modal: {
            close: "Sulje"
        }
    }
};
